// extracted by mini-css-extract-plugin
export default {"heading":"OrganizationsTemplate_heading__ldIPM"};